var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 15px"},on:{"click":_vm.toggleClick}},[_c('icon',{staticStyle:{"color":"#fb2626"},attrs:{"icon-class":"saasicon_more"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }